export default {
    parametros: null
}
